import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  DUMMY_SITE_NAME,
  getDummySiteDetail,
} from "src/assets/mockData/dummySite";

import apiClient from "src/utils/apiClient";
export type SiteDetail = {
  site: string;
  org: string;
  suborg: string;
  siteType: string;
  country: string;
  region: string;
  processPath: Record<string, string[]>;
};
export interface AssessmentInfo extends SiteDetail {}
export type DataState = {
  currentErgonaSites: string[];
  currentSiteDetails: SiteDetail;
  currentProcessPathsList: string[];
  currentProcessPath: string;
  currentActivitiesList: string[];
  currentActivity: string;
  assessmentInfo: AssessmentInfo;
};

const initialState: DataState = {
  currentErgonaSites: [],
  currentSiteDetails: {
    site: "",
    org: "",
    suborg: "",
    siteType: "",
    country: "",
    region: "",
    processPath: {},
  },
  currentProcessPathsList: [],
  currentProcessPath: "",
  currentActivitiesList: [],
  currentActivity: "",
  assessmentInfo: {
    site: "",
    org: "",
    suborg: "",
    siteType: "",
    country: "",
    region: "",
    processPath: {},
  },
};

/**
 * get the authenticated user
 * @returns {Object}
 */

export const getUserSites = createAsyncThunk("data/getUserSites", async () => {
  try {
    const response = await apiClient.get("/getSites");
    if (response.data) {
      return {
        ...response.data,
        sites: [...(response.data.sites || []), DUMMY_SITE_NAME],
      };
    }
  } catch (error) {
    console.log("Error getting user's sites");
  }
});
export const getSelectedSiteDetails = createAsyncThunk(
  "data/getSelectedSiteDetails",
  async (site: string) => {
    if (site === DUMMY_SITE_NAME) {
      return { siteDetail: getDummySiteDetail() };
    }
    try {
      const response = await apiClient.get(`/getSiteDetail?site=${site}`);
      if (response.data) {
        return response.data;
      }
    } catch (error) {
      console.log("Error getting user's sites");
    }
  },
);
export const getAssessmentInfo = createAsyncThunk(
  "data/getAssessmentInfo",
  async (site: string) => {
    try {
      const response = await apiClient.get(`/getSiteDetail?site=${site}`);
      const data = response.data;
      if (data) {
        return data.siteDetail;
      }
    } catch (error) {
      console.log("Error getting user's sites");
    }
  },
);

/** User Slice */
const { reducer, actions } = createSlice({
  name: "data",
  initialState,
  reducers: {
    setCurrentProcessPath: (state, { payload }) => {
      state.currentProcessPath = payload;
    },
    setCurrentActivity: (state, { payload }) => {
      state.currentActivity = payload;
    },
    setCurrentActivitiesList: (state, { payload }) => {
      state.currentActivitiesList = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserSites.fulfilled, (state, { payload }) => {
      state.currentErgonaSites = payload.sites;
    });
    builder.addCase(getSelectedSiteDetails.fulfilled, (state, { payload }) => {
      state.currentSiteDetails = payload.siteDetail;
      const processPath = payload.siteDetail.processPath;
      state.currentProcessPathsList = Object.keys(processPath);
    });
    builder.addCase(getAssessmentInfo.fulfilled, (state, { payload }) => {
      state.assessmentInfo = payload;
    });
  },
});

export const {
  setCurrentProcessPath,
  setCurrentActivity,
  setCurrentActivitiesList,
} = actions;

export default reducer;
